import { createGlobalStyle } from 'styled-components';
import { blue100 } from '@zocdoc-mezzanine/foundations-colors';

/*
 * Fix Iframe jumping behavior due to iOS browsers not correctly calculating iFrame height
 * https://stackoverflow.com/questions/34766636/ios-browser-iframe-jumps-to-top-when-changing-css-or-content-using-javascript
 */

/*
 * #main style: fix i.e. flex bug where page does not expand to full height
 * https://stackoverflow.com/questions/44700068/how-to-make-a-sticky-footer-using-flexbox-in-ie11
 */
export default createGlobalStyle`
    html, body {
        color: ${blue100};
        height: 100%;
        -webkit-overflow-scrolling: touch;
        background: #F3F3F3;
    }

    #main {
        display: flex;
        flex-direction: column;
    }
`;
